module.exports = __webpack_public_path__ + "img/dxtrade-logo.2c31b30d.svg";